/** MI DOMINO - lightweight top-center toast (visible on any screen, unlike the
 *  game banner). Leaf module: no app imports. */
export function toast(msg: string): void {
  const el = document.createElement('div');
  el.textContent = msg;
  el.style.cssText = 'position:fixed;left:50%;top:16px;transform:translateX(-50%);z-index:9800;background:linear-gradient(180deg,#1b2b4a,#12203a);border:1.5px solid #f0b429;color:#f5ead0;padding:12px 20px;border-radius:12px;font-weight:800;font-size:15px;box-shadow:0 12px 30px -8px rgba(0,0,0,.8);opacity:0;transition:opacity .3s, top .3s;max-width:90vw;text-align:center';
  document.body.appendChild(el);
  requestAnimationFrame(() => { el.style.opacity = '1'; el.style.top = '28px'; });
  setTimeout(() => { el.style.opacity = '0'; el.style.top = '16px'; setTimeout(() => el.remove(), 400); }, 3400);
}
